import { useStore } from "stores/store";

// use this only when editing user as an admin
export const useListUser = () => {
  const listUser = useStore((state) => state.listUser);
  return listUser;
};
